// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title":"accordion-toggle__title--z2hDL","active":"accordion-toggle__active--2xECa"};